module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel shaded"
  }, [_c('h5', [_vm._v("Extra Ticket Information")]), _vm._v(" "), _c('div', {
    staticClass: "fs-small dark"
  }, [_vm._v("This information will be added on the customer’s ticket depending on the following conditions:")]), _vm._v(" "), _c('div', _vm._l((_vm.activeTicketExtraInformation), function(ticketExtraInformation) {
    return _c('div', {
      staticClass: "mt-3"
    }, [_c('div', {
      staticClass: "d-flex flex-row dark bold"
    }, [_c('div', {
      staticClass: "flex-grow-1"
    }, [_vm._v(_vm._s(ticketExtraInformation.label))]), _vm._v(" "), _c('div', {
      staticClass: "pointer",
      on: {
        "click": function($event) {
          return _vm.removeExtraInfo(ticketExtraInformation)
        }
      }
    }, [_vm._v("Remove")])]), _vm._v(" "), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (ticketExtraInformation.text),
        expression: "ticketExtraInformation.text"
      }],
      domProps: {
        "value": (ticketExtraInformation.text)
      },
      on: {
        "change": function($event) {
          return _vm.somethingChanged()
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(ticketExtraInformation, "text", $event.target.value)
        }
      }
    })])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-end align-items-center mt-3"
  }, [_c('div', {
    staticClass: "mr-3"
  }, [_c('v-select', {
    attrs: {
      "options": _vm.availableOptions,
      "disabled": _vm.noOptionsAvailable,
      "label": "label"
    },
    model: {
      value: (_vm.selectedOption),
      callback: function($$v) {
        _vm.selectedOption = $$v
      },
      expression: "selectedOption"
    }
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "btn blue wide",
    attrs: {
      "type": "button",
      "disabled": _vm.noOptionsAvailable
    },
    on: {
      "click": function($event) {
        return _vm.addExtraInfoToProduct(_vm.selectedOption)
      }
    }
  }, [_vm._v("Add")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-078aae6a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inventory/products/components/TicketExtraInfo.vue
// module id = 1481
// module chunks = 0